import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import SwitchFilter from 'components/FilterFields/SwitchFilter';
import { LISTINGS, RENTALS } from 'constants/comparableTypes';

const ACTIVE_LISTINGS_CONFIG = {
    [LISTINGS]: { attr: 'isActiveForSaleCampaign' },
    [RENTALS]: { attr: 'isActiveForRentCampaign' },
};

const ActiveListingsFilter = React.memo(function ActiveListingsFilter({ comparableType, sx = {} }) {
    const config = ACTIVE_LISTINGS_CONFIG[comparableType];

    if (!config) return null;

    return (
        <Box sx={sx}>
            <SwitchFilter
                attr={config.attr}
                label="Show active listings only"
                comparableType={comparableType}
                tooltip="Excludes listings known to be removed from the market"
            />
        </Box>
    );
});

ActiveListingsFilter.propTypes = {
    comparableType: PropTypes.string,
};

export default ActiveListingsFilter;
